import React, { Component } from 'react'
import { observer } from 'mobx-react'

import WelcomePage from './pagesv4/WelcomePagev4'
import DefaultPage from './pagesv4/DefaultPagev4'
import CompletionPage from './pagesv4/CompletionPagev4'
import ScreeningExitPage from './pagesv4/ScreeningExitPagev4'
import QuotaFullPage from './pages/QuotaFullPage'

import '../assets/css/surveypage.css'

@observer
class SurveyPage extends Component {
    render() {
        const {
            page_id,
            page,
            store,
            history,
            provided,
            pageDragId,
            draggableId,
            isFirstExitPage,
        } = this.props
        const { pageType } = page
        const pageId = page_id
        let renderPage
        if (pageType === 'welcome') {
            renderPage = <WelcomePage store={store} page_id={pageId} page={page} />
        } else if (pageType === 'CO') {
            renderPage = (
                <CompletionPage
                    store={store}
                    page_id={pageId}
                    page={page}
                    isFirstExitPage={isFirstExitPage}
                />
            )
        } else if (pageType === 'EX') {
            renderPage = <ScreeningExitPage store={store} page_id={pageId} page={page} />
        } else if (pageType === 'QF') {
            renderPage = <QuotaFullPage store={store} page_id={pageId} page={page} />
        } else {
            const classes = `${(page.isHidden) ? 'disabled' : ''}`
            renderPage = (
                <div ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}>
                    <div cssClass={classes}>
                        <DefaultPage
                            store={store}
                            page_id={pageId}
                            page={page}
                            history={history}
                            pageDragId={pageDragId}
                            draggableId={draggableId}
                        />
                    </div>
                </div>
            )
        }

        return renderPage
    }
}

export default SurveyPage
